import { render, staticRenderFns } from "./HeroBar.vue?vue&type=template&id=f84ee62c"
import script from "./HeroBar.vue?vue&type=script&lang=js"
export * from "./HeroBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports